// cross browsers addRule method
import { raf } from './raf.js';
export function removeCSSRule(sheet, index) {
  // return raf(function() {
    'deleteRule' in sheet ?
      sheet.deleteRule(index) :
      sheet.removeRule(index);
  // });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/removeCSSRule.js
// module id = 76
// module chunks = 0